// @core/api/endpoints/tenant/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AddTenantMember } from './add_tenant_member';
import { ApproveTenantMigration } from './approve_tenant_migration';
import { CancelTenantMigration } from './cancel_tenant_migration';
import { CompleteTenantOnboarding } from './complete_tenant_onboarding';
import { CreateTenant } from './create_tenant';
import { DeleteTenant } from './delete_tenant';
import { DeleteTenantSSOConfig } from './delete_tenant_sso_config';
import { ExportTenantData } from './export_tenant_data';
import { GetTenant } from './get_tenant';
import { GetTenantAnalytics } from './get_tenant_analytics';
import { GetTenantDataExport } from './get_tenant_data_export';
import { GetTenantEntitlements } from './get_tenant_entitlements';
import { GetTenantMigration } from './get_tenant_migration';
import { GetTenantOnboarding } from './get_tenant_onboarding';
import { GetTenantQuota } from './get_tenant_quota';
import { GetTenantSSOConfig } from './get_tenant_sso_config';
import { GetTenantSettings } from './get_tenant_settings';
import { GetTenantSuspensionHistory } from './get_tenant_suspension_history';
import { ListTenantDataExports } from './list_tenant_data_exports';
import { ListTenantMembers } from './list_tenant_members';
import { ListTenantMigrations } from './list_tenant_migrations';
import { ListTenants } from './list_tenants';
import { ReactivateTenant } from './reactivate_tenant';
import { RemoveTenantMember } from './remove_tenant_member';
import { RequestTenantMigration } from './request_tenant_migration';
import { SuspendTenant } from './suspend_tenant';
import { TestTenantSSOConfig } from './test_tenant_sso_config';
import { TransferTenantOwnership } from './transfer_tenant_ownership';
import { UpdateTenant } from './update_tenant';
import { UpdateTenantMemberRole } from './update_tenant_member_role';
import { UpdateTenantOnboarding } from './update_tenant_onboarding';
import { UpdateTenantQuota } from './update_tenant_quota';
import { UpdateTenantSSOConfig } from './update_tenant_sso_config';
import { UpdateTenantSettings } from './update_tenant_settings';

// Re-export individual endpoints
export {
  AddTenantMember,
  ApproveTenantMigration,
  CancelTenantMigration,
  CompleteTenantOnboarding,
  CreateTenant,
  DeleteTenant,
  DeleteTenantSSOConfig,
  ExportTenantData,
  GetTenant,
  GetTenantAnalytics,
  GetTenantDataExport,
  GetTenantEntitlements,
  GetTenantMigration,
  GetTenantOnboarding,
  GetTenantQuota,
  GetTenantSSOConfig,
  GetTenantSettings,
  GetTenantSuspensionHistory,
  ListTenantDataExports,
  ListTenantMembers,
  ListTenantMigrations,
  ListTenants,
  ReactivateTenant,
  RemoveTenantMember,
  RequestTenantMigration,
  SuspendTenant,
  TestTenantSSOConfig,
  TransferTenantOwnership,
  UpdateTenant,
  UpdateTenantMemberRole,
  UpdateTenantOnboarding,
  UpdateTenantQuota,
  UpdateTenantSSOConfig,
  UpdateTenantSettings,
};

// Namespace export for convenient usage
export const tenantApi = {
  AddTenantMember,
  ApproveTenantMigration,
  CancelTenantMigration,
  CompleteTenantOnboarding,
  CreateTenant,
  DeleteTenant,
  DeleteTenantSSOConfig,
  ExportTenantData,
  GetTenant,
  GetTenantAnalytics,
  GetTenantDataExport,
  GetTenantEntitlements,
  GetTenantMigration,
  GetTenantOnboarding,
  GetTenantQuota,
  GetTenantSSOConfig,
  GetTenantSettings,
  GetTenantSuspensionHistory,
  ListTenantDataExports,
  ListTenantMembers,
  ListTenantMigrations,
  ListTenants,
  ReactivateTenant,
  RemoveTenantMember,
  RequestTenantMigration,
  SuspendTenant,
  TestTenantSSOConfig,
  TransferTenantOwnership,
  UpdateTenant,
  UpdateTenantMemberRole,
  UpdateTenantOnboarding,
  UpdateTenantQuota,
  UpdateTenantSSOConfig,
  UpdateTenantSettings,
};
